import { render, staticRenderFns } from "./deleteShopVipLevel.vue?vue&type=template&id=afc9579e"
import script from "./deleteShopVipLevel.vue?vue&type=script&lang=js"
export * from "./deleteShopVipLevel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports